import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiError } from "@/lib/api";
import { Analytics } from "@/lib/analyticsShim";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("rm_token", data.token);
    setUser(data);
    return data;
  };

  const register = async (payload, isMultipart = false) => {
    const config = isMultipart ? { headers: { "Content-Type": "multipart/form-data" } } : undefined;
    const { data } = await api.post("/auth/register", payload, config);
    if (data.token) localStorage.setItem("rm_token", data.token);
    if (data.token) setUser(data);
    return data;
  };

  const requestOtp = async (payload) => {
    const { data } = await api.post("/auth/request-otp", payload);
    return data;
  };

  const loginWithOtp = async (payload) => {
    const { data } = await api.post("/auth/login-otp", payload);
    if (data.token) localStorage.setItem("rm_token", data.token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("rm_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        login,
        register,
        requestOtp,
        loginWithOtp,
        logout,
        refresh: fetchMe,
        formatApiError,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
